/* eslint-disable import/max-dependencies */
import React from "react";
import { Delete, Edit } from "@mui/icons-material";
import {
  SimpleTableActionButton, TableActions, TableActionGroup,
  ConfirmTableActionButton,
} from "@fas/ui-core";
import { useDispatch, useSelector } from "react-redux";
import { getTableSelections } from "@fas/ui-framework";
import { REDIRECT_LIST } from "../../helpers/constants";
import externalRedirect from "../../helpers/ExternalRedirect";
import { deleteRedirect } from "../../actions/redirectList/actions";
import { getHashValue } from "../../services/jusCan";
import type { State } from "../../pages/AppStoreWrapper";
import type { Redirect } from "../../reducers/redirectList";

function RedirectListActions() {
  const items = useSelector(
    (state: State): Array<Redirect> => getTableSelections(state, REDIRECT_LIST)
  );
  const dispatch = useDispatch();

  const handleEdit = (id: string) => {
    externalRedirect({ to: `/redirects/edit/${id}?hashId=${getHashValue()}`, target: "_blank" });
  };

  return (
    <TableActions>
      <TableActionGroup>
        <SimpleTableActionButton
          tooltip="Edit"
          disabled={items.length > 1}
          onClick={() => handleEdit(items[0]?.id as string)}
          Icon={<Edit />}
        />
        <ConfirmTableActionButton
          tooltip="Delete"
          items={items}
          viewPath={`/redirects/edit/:id?hashId=${getHashValue()}`}
          confirmTitle="Deleting items"
          confirmText="Are you sure you want to delete"
          onClick={() => dispatch(deleteRedirect())}
          Icon={<Delete />}
        />
      </TableActionGroup>
    </TableActions>
  );
}

export default RedirectListActions;
